const options = [
	{
		label: '标签1',
		value: 'value1'
	}
]

const treeOptions = [
	{
		label: '标签1',
		value: 'value1',
		children: [
			{
				label: '标签11',
				value: 'value11'
			}
		]
	},
	{
		label: '标签2',
		value: 'value2',
		children: [
			{
				label: '标签21',
				value: 'value21'
			}
		]
	}
]

export interface IWidgetForm {
	list: IWidgetFormItem[]
	config: {
		size: any
		labelWidth: number
		labelPosition: any
		style: string
	}
}

export interface IWidgetFormItem {
	type: string
	label: string
	name?: string
	columns?: IWidgetFormItemColumn[]
	options: {
		defaultValue: string | number | any[]
		width: string
		maxlength: number
		rows: number
		min: number
		max: number
		step: number
		precision: number
		height: number
		controlsPosition: null
		format: string
		button: boolean
		allowHalf: boolean
		filterable: boolean
		multiple: boolean
		isRange: boolean
		placeholder: string
		startPlaceholder: string
		endPlaceholder: string
		type: string
		href: string
		underline: boolean
		blank: boolean
		labelHide: boolean
		disabled: boolean
		readonly: boolean
		clearable: boolean
		showPassword: boolean
		showWordLimit: boolean
		options: any[]
		optionsType: string //option、var、dict
		varName: string
		dictName: string
		props: any
		size: string
		rules: any[]
		gutter: number
		justify: string
		align: string
	}
}

export interface IWidgetFormItemColumn {
	span: number
	list: any[]
}

export const defaultWidgetFormData: IWidgetForm = {
	list: [],
	config: {
		size: 'default',
		labelWidth: 100,
		labelPosition: 'right',
		style: ''
	}
}

export const formList = [
	{
		title: '基础字段',
		children: [
			{
				type: 'input',
				label: '单行文本',
				options: {
					defaultValue: '',
					width: '',
					maxlength: null,
					placeholder: null,
					labelHide: false,
					disabled: false,
					readonly: false,
					clearable: false,
					showPassword: false,
					showWordLimit: false,
					rules: []
				}
			},
			{
				type: 'textarea',
				label: '多行文本',
				options: {
					defaultValue: '',
					width: '',
					maxlength: null,
					placeholder: null,
					rows: 2,
					labelHide: false,
					disabled: false,
					readonly: false,
					clearable: false,
					showWordLimit: false,
					rules: []
				}
			},
			{
				type: 'number',
				label: '计数器',
				options: {
					defaultValue: 0,
					width: '',
					min: 0,
					max: 999999999,
					step: 1,
					precision: 0,
					controlsPosition: '',
					labelHide: false,
					disabled: false,
					readonly: false,
					rules: []
				}
			},
			{
				type: 'radio',
				label: '单选框组',
				options: {
					defaultValue: '',
					width: '',
					button: false,
					labelHide: false,
					disabled: false,
					options: options,
					optionsType: 'option',
					varName: '',
					dictName: '',
					props: { value: 'value', label: 'label' },
					rules: []
				}
			},
			{
				type: 'checkbox',
				label: '多选框组',
				options: {
					defaultValue: '',
					button: false,
					labelHide: false,
					disabled: false,
					options: options,
					optionsType: 'option',
					varName: '',
					dictName: '',
					props: { value: 'value', label: 'label' },
					rules: []
				}
			},
			{
				type: 'select',
				label: '下拉选择框',
				options: {
					defaultValue: '',
					width: '',
					multiple: false,
					placeholder: null,
					labelHide: false,
					filterable: false,
					clearable: false,
					disabled: false,
					options: options,
					optionsType: 'option',
					varName: '',
					dictName: '',
					props: { value: 'value', label: 'label' },
					rules: []
				}
			},
			{
				type: 'date',
				label: '日期选择器',
				options: {
					defaultValue: '',
					width: '',
					type: 'date',
					format: 'YYYY-MM-DD',
					placeholder: null,
					startPlaceholder: null,
					endPlaceholder: null,
					labelHide: false,
					clearable: true,
					disabled: false,
					rules: []
				}
			},
			{
				type: 'time',
				label: '时间选择器',
				options: {
					defaultValue: '',
					width: '',
					format: 'HH:mm:ss',
					isRange: false,
					placeholder: null,
					startPlaceholder: null,
					endPlaceholder: null,
					labelHide: false,
					clearable: true,
					disabled: false,
					rules: []
				}
			},

			{
				type: 'rate',
				label: '评分',
				options: {
					defaultValue: 0,
					width: '',
					max: 5,
					allowHalf: false,
					labelHide: false,
					clearable: true,
					disabled: false,
					rules: []
				}
			},
			{
				type: 'switch',
				label: '开关',
				options: {
					defaultValue: false,
					activeText: '',
					inactiveText: '',
					labelHide: false,
					disabled: false,
					rules: []
				}
			},
			{
				type: 'slider',
				label: '滑块',
				options: {
					defaultValue: 0,
					width: '',
					min: 0,
					max: 100,
					step: 1,
					showInput: false,
					labelHide: false,
					disabled: false,
					rules: []
				}
			},
			{
				type: 'text',
				label: '文字',
				options: {
					defaultValue: 'This is a text',
					type: '',
					size: '',
					labelHide: false
				}
			},
			{
				type: 'link',
				label: '文字链接',
				options: {
					defaultValue: 'Link',
					type: 'default',
					href: '',
					underline: false,
					labelHide: false
				}
			},
			{
				type: 'editor',
				label: '富文本',
				options: {
					defaultValue: '',
					height: 300,
					disabled: false,
					labelHide: false,
					rules: []
				}
			},
			{
				type: 'image',
				label: '图片上传',
				options: {
					defaultValue: '',
					multiple: false,
					limit: 9,
					labelHide: false,
					rules: []
				}
			},
			{
				type: 'file',
				label: '文件上传',
				options: {
					defaultValue: '',
					multiple: false,
					limit: 9,
					labelHide: false,
					rules: []
				}
			},
			{
				type: 'cascader',
				label: '级联选择器',
				options: {
					defaultValue: '',
					width: '100%',
					multiple: false,
					checkStrictly: false,
					placeholder: null,
					filterable: false,
					options: treeOptions,
					optionsType: 'option',
					varName: '',
					dictName: '',
					props: { value: 'value', label: 'label' },
					clearable: false,
					disabled: false,
					labelHide: false,
					rules: []
				}
			},
			{
				type: 'treeselect',
				label: '树选择器',
				options: {
					defaultValue: '',
					width: '100%',
					multiple: false,
					placeholder: null,
					filterable: false,
					checkStrictly: false,
					options: treeOptions,
					optionsType: 'option',
					varName: '',
					dictName: '',
					props: { value: 'value', label: 'label' },
					clearable: false,
					disabled: false,
					labelHide: false,
					rules: []
				}
			},
			{
				type: 'address',
				label: '省市区选择',
				options: {
					defaultValue: '',
					width: '100%',
					placeholder: null,
					props: { value: 'value', label: 'label' },
					clearable: false,
					disabled: false,
					labelHide: false,
					rules: []
				}
			},

			{
				type: 'org',
				label: '机构选择',
				options: {
					defaultValue: '',
					placeholder: null,
					labelHide: false,
					disabled: false,
					rules: []
				}
			},

			{
				type: 'post',
				label: '岗位选择',
				options: {
					defaultValue: '',
					placeholder: null,
					labelHide: false,
					disabled: false,
					rules: []
				}
			}
		]
	},
	{
		title: '布局字段',
		children: [
			{
				type: 'grid',
				label: '格栅布局',
				columns: [
					{
						span: 12,
						list: []
					},
					{
						span: 12,
						list: []
					}
				],
				options: {
					gutter: 0,
					justify: 'start',
					align: 'top'
				}
			},
			{
				type: 'divider',
				label: '分割线',
				options: {
					defaultValue: '',
					position: 'left',
					labelHide: true
				}
			}
		]
	},
	{
		title: '自定义字段',
		children: [
			{
				type: 'device',
				label: '设备',
				options: {
					defaultValue: '',
					placeholder: '设备选择',
					labelHide: false,
					disabled: false,
					rules: []
				}
			},
			{
				type: 'deviceBiz',
				label: '设备(诊断)',
				options: {
					defaultValue: '',
					placeholder: '设备选择',
					labelHide: false,
					disabled: false,
					rules: []
				}
			},
			{
				type: 'orgBiz',
				label: '机构(诊断)',
				options: {
					defaultValue: '',
					placeholder: '机构(诊断)',
					labelHide: false,
					disabled: false,
					rules: []
				}
			},
			{
				type: 'user',
				label: '用户选择',
				options: {
					defaultValue: '',
					placeholder: null,
					labelHide: false,
					disabled: false,
					rules: []
				}
			},
			{
				type: 'icon',
				label: 'icon',
				options: {
					defaultValue: '',
					placeholder: null,
					labelHide: false,
					disabled: false,
					rules: []
				}
			}
		]
	}
]
